module.exports = __webpack_public_path__ + "img/GelassenBeerig.09cde629.svg";